import { useLayoutEffect, useRef, useState } from 'react';
import { Trello } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export default function TrelloCallback() {
  const handled = useRef(false);
  const [returned, setReturned] = useState(false);

  useLayoutEffect(() => {
    if (handled.current) return;
    handled.current = true;
    const params = new URLSearchParams(window.location.search);
    const payload = { type: 'trello-personal-oauth', code: params.get('code'), state: params.get('state'), error: params.get('error') };
    window.history.replaceState(window.history.state, '', window.location.pathname);
    if (window.opener && payload.state && (payload.code || payload.error)) {
      window.opener.postMessage(payload, window.location.origin);
      setReturned(true);
    }
  }, []);

  return <main className="flex min-h-dvh items-center justify-center bg-background p-4 text-foreground">
    <Card className="w-full max-w-md">
      <CardHeader><CardTitle className="flex items-center gap-2"><Trello className="h-5 w-5 text-primary" />Conexão Trello</CardTitle></CardHeader>
      <CardContent className="space-y-4">
        <p role="status" className="text-sm text-foreground-muted">{returned ? 'Retorno recebido. Volte à Touch para acompanhar a conclusão da autorização.' : 'Inicie a conexão pela Touch, em Usuários ou no cartão do contato, para autorizar sua conta Trello.'}</p>
        {returned && <Button variant="outline" onClick={() => window.close()}>Fechar janela</Button>}
      </CardContent>
    </Card>
  </main>;
}
